export enum RefundTypeEnum {
    ProgramCost = 0,
    PackCost = 1,
    TotalCost = 2,
}